__turbopack_context__.v({
  "filter-stack": "tfU8Aq_filter-stack",
  "filter-stack__item": "tfU8Aq_filter-stack__item",
  "switch-filter": "tfU8Aq_switch-filter",
});
